import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pop_container" }
const _hoisted_2 = { style: {"padding":"5px 20px"} }
const _hoisted_3 = {
  key: 0,
  class: "register_container"
}
const _hoisted_4 = {
  class: "form_container",
  style: {"padding":"0px"}
}
const _hoisted_5 = {
  key: 1,
  class: "register_container"
}
const _hoisted_6 = { class: "form_container" }
const _hoisted_7 = {
  key: 0,
  class: "errorNotice"
}
const _hoisted_8 = {
  key: 0,
  class: "errorNotice"
}
const _hoisted_9 = {
  key: 2,
  class: "errorNotice"
}
const _hoisted_10 = {
  key: 3,
  class: "errorNotice"
}
const _hoisted_11 = { key: 5 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 0,
  class: "errorNotice"
}
const _hoisted_14 = {
  key: 6,
  class: "human_verify"
}
const _hoisted_15 = { class: "btn_container" }
const _hoisted_16 = { class: "bottomText" }

import { ref, computed, nextTick, watch, onBeforeMount } from 'vue';
import InputField from './components/inputField.vue';
import CaptchaField from './components/captchaField.vue';
import { RegisterLoginData, startCountdown, stopLoading } from '@/view/loginRegister/supportScript';
import MainButton from '../components/common/mainButton.vue';
import SliderCaptcha from '@/themes/themeOne/components/sliderCaptcha.vue';
import { useI18n } from 'vue-i18n';
import ResetPasswordPopup from './components/resetPasswordPopup.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'registerLoginPopup',
  props: {
    dataSet: {}
  },
  emits: ['open', 'close', 'changeSignType', 'phoneNumberChange', 'smsOTPChange', 'whatsappOTPChange', 
'emailChange', 'emailOTPChange', 'passwordChange', 'confirmPasswordChange', 'captchaChage', 'signIn', 'signUp', 
'getCaptchaImageData', 'getSMSOTP', 'getWhatsappOTP', 'getEmailOTP', 'turnstileTokenChange', 
'turnstile-error', 'forgetPassword', 'phoneNumberChangeInResetPW'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
// Macros are auto-imported in <script setup>, but if explicitly imported, ensure consistent usage.
// To fix "emits not defined", we'll move the definition to the top.

const props = __props

const emits = __emit

const emailOTPRef = ref()
const smsOTPRef = ref()
const whatsappOTPRef = ref()
const turnstileContainer = ref()
const turnstileWidgetId = ref('')
const turnstileRetryCount = ref(0)
const showSliderCaptcha = ref(false)
const currentAction = ref<'signIn' | 'signUp'>('signUp')

const show = ref(props.dataSet.show)
const phoneNumber = ref(props.dataSet.phoneNumber)
const email = ref(props.dataSet.email)
const password = ref(props.dataSet.password)
const confirmPassword = ref(props.dataSet.confirmPassword)
const smsOTP = ref(props.dataSet.smsOTP)
const whatsappOTP = ref(props.dataSet.whatsappOTP)
const emailOTP = ref(props.dataSet.emailOTP)
const captcha = ref(props.dataSet.captcha)
const active = ref(props.dataSet.signType);
watch(() => props.dataSet.signType, (newVal) => {
  active.value = newVal;
});
// const active = computed(() => props.dataSet.signType)
const tabList = computed(() =>([
    { index: 1, title: t('common.login') },
    { index: 0, title: t('common.register') },
    { index: 2, title: t('common.resetPasswordNow') }
]));

const renderTurnstile = () => {
    nextTick(() => {
        if (turnstileContainer.value && !turnstileWidgetId.value && (window as any).turnstile) {
            try {
                turnstileWidgetId.value = (window as any).turnstile.render(turnstileContainer.value, {
                    sitekey: props.dataSet.cloudFlareSiteKey,
                    theme: 'dark',
                    retry: 'never',
                    callback: (token: string) => {
                        emits('turnstileTokenChange', token)
                    },
                    'error-callback': () => {
                        emits('turnstile-error', 'error');
                        if (turnstileRetryCount.value < 3) {
                            turnstileRetryCount.value++;
                            if (turnstileWidgetId.value) (window as any).turnstile.reset(turnstileWidgetId.value);
                        }
                    },
                    'expired-callback': () => {
                        emits('turnstileTokenChange', '');
                    }
                });
            } catch (e) {
                console.error('Turnstile render error:', e);
            }
        }
    })
}

const removeTurnstile = () => {
    if (turnstileWidgetId.value && (window as any).turnstile) {
        try {
            (window as any).turnstile.remove(turnstileWidgetId.value);
        } catch (e) {
            console.error('Turnstile remove error:', e);
        }
        turnstileWidgetId.value = '';
        emits('turnstileTokenChange', '');
    }
}

const resetTurnstile = () => {
    if (turnstileWidgetId.value && (window as any).turnstile) {
        try {
            (window as any).turnstile.reset(turnstileWidgetId.value);
        } catch (e) {
            console.error('Turnstile reset error:', e);
        }
        emits('turnstileTokenChange', '');
    }
}

const handleOpened = () => {
    if (props.dataSet.cloudFlareCaptchaEnabled && props.dataSet.signType == 0) {
        renderTurnstile()
    }
}

const handleClosed = () => {
    turnstileRetryCount.value = 0;
    removeTurnstile()
}

watch(() => props.dataSet.cloudFlareCaptchaEnabled, (newVal) => {
    if (newVal && props.dataSet.signType == 0) {
        renderTurnstile()
    } else {
        removeTurnstile()
    }
})

watch(() => props.dataSet.signType, (newVal) => {
    if (props.dataSet.cloudFlareCaptchaEnabled) {
        if (newVal == 0) {
            renderTurnstile()
        } else {
            removeTurnstile()
        }
    }
})

const close = () => {
    emits('close')
}

const changeTab = (index: number) => {
    // active.value = index
    changeSignType(index)

}

const changeSignType = (value: number) => {
    emits('changeSignType', value)
}

const phoneNumberChange = (value: string) => {
    emits('phoneNumberChange', value)
}
const smsOTPChange = (value: string) => {
    emits('smsOTPChange', value)
}
const whatsappOTPChange = (value: string) => {
    emits('whatsappOTPChange', value)
}
const emailChange = (value: string) => {
    emits('emailChange', value)
}

const emailOTPChange = (value: string) => {
    emits('emailOTPChange', value)
}

const passwordChange = (value: string) => {
    emits('passwordChange', value)
}

const confirmPasswordChange = (value: string) => {
    emits('confirmPasswordChange', value)
}
const captchaChage = (value: string) => {
    emits('captchaChage', value)
}
const signIn = (isReg: boolean) => {
    emits('signIn', isReg)
}

const forgetPassword = () => {
    emits('forgetPassword')
}

const signUp = () => {
    if (props.dataSet.sliderEnabled) {
        currentAction.value = 'signUp';
        showSliderCaptcha.value = true;
    } else {
        emits('signUp');
    }
}

const handleCaptchaSuccess = (data: any) => {
    if (currentAction.value === 'signUp') {
        emits('signUp', data);
    } else {
        emits('signIn', false, data);
    }
}

const getCaptchaImageData = () => {
    emits('getCaptchaImageData')
}


const getSMSOTP = () => {
    emits('getSMSOTP')

}

const getWhatsappOTP = () => {
    emits('getWhatsappOTP')

}

const getEmailOTP = () => {
    emits('getEmailOTP')
}

const handleStartCountdown = (type: 'sms' | 'whatsapp' | 'email') => {
    startCountdown({ sms: smsOTPRef, whatsapp: whatsappOTPRef, email: emailOTPRef }, type)
}

const handleStopLoading = (type: 'sms' | 'whatsapp' | 'email') => {
    stopLoading({ sms: smsOTPRef, whatsapp: whatsappOTPRef, email: emailOTPRef }, type)
}

const phoneNumberChangeInResetPW = (value: string) => {
    emits('phoneNumberChangeInResetPW', value)
}

const handlePasswordResetCompleted = () => {
  active.value = 1;
  changeSignType(1);
};

watch(() => props.dataSet, (newDataSet) => {
    phoneNumber.value = newDataSet.phoneNumber;
    email.value = newDataSet.email;
    password.value = newDataSet.password;
    confirmPassword.value = newDataSet.confirmPassword;
    smsOTP.value = newDataSet.smsOTP;
    whatsappOTP.value = newDataSet.whatsappOTP;
    emailOTP.value = newDataSet.emailOTP;
    captcha.value = newDataSet.captcha;
}, { deep: true });
__expose({
    handleStartCountdown,
    handleStopLoading,
    resetTurnstile
})

return (_ctx: any,_cache: any) => {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    onOpened: handleOpened,
    onClosed: handleClosed,
    style: {
        minWidth: '100%',
        minHeight: '45%',
        zIndex: '10002'
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_tabs, {
            class: "regLoginTab",
            active: active.value,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
            onChange: changeTab,
            "line-width": "30%",
            "title-inactive-color": "#ffffff80",
            "title-active-color": "#fff"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (tab, index) => {
                return (_openBlock(), _createBlock(_component_van_tab, {
                  "title-style": { fontSize: '0.9rem' },
                  key: index,
                  title: tab.title,
                  name: tab.index
                }, null, 8, ["title", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["active"])
        ]),
        (_ctx.dataSet?.signType == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(ResetPasswordPopup, {
                  ref: "resetPWPopupRef",
                  dataSet: _ctx.dataSet,
                  onValueChanged: phoneNumberChangeInResetPW,
                  onPasswordResetCompleted: handlePasswordResetCompleted
                }, null, 8, ["dataSet"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(InputField, {
                  modelValue: phoneNumber.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phoneNumber).value = $event)),
                  isShowError: _ctx.dataSet?.phoneValidationNotice,
                  onValueChanged: phoneNumberChange,
                  labelText: _ctx.$t('profile.phoneNum'),
                  isshowFlag: true,
                  fieldType: "number"
                }, null, 8, ["modelValue", "isShowError", "labelText"]),
                _createElementVNode("div", null, [
                  (_ctx.dataSet?.phoneValidationNotice)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('loginRegister.phoneFormat')), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(InputField, {
                  modelValue: password.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                  isShowError: _ctx.dataSet?.passwordValidationNotice,
                  onValueChanged: passwordChange,
                  isPassword: true,
                  labelText: _ctx.$t('loginRegister.enterPassword'),
                  fieldType: "password"
                }, null, 8, ["modelValue", "isShowError", "labelText"]),
                (_ctx.dataSet?.passwordValidationNotice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('loginRegister.passwordForamt')), 1))
                  : _createCommentVNode("", true),
                (_ctx.dataSet?.signType == 0)
                  ? (_openBlock(), _createBlock(InputField, {
                      key: 1,
                      modelValue: confirmPassword.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confirmPassword).value = $event)),
                      isShowError: _ctx.dataSet?.confirmPasswordValidationNotice || (_ctx.dataSet?.password !== '' && _ctx.dataSet?.confirmPassword !== '' && _ctx.dataSet?.password !== _ctx.dataSet?.confirmPassword),
                      onValueChanged: confirmPasswordChange,
                      isPassword: true,
                      labelText: _ctx.$t('loginRegister.confirmPassword'),
                      fieldType: "password"
                    }, null, 8, ["modelValue", "isShowError", "labelText"]))
                  : _createCommentVNode("", true),
                (_ctx.dataSet?.confirmPasswordValidationNotice)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('loginRegister.passwordForamt')), 1))
                  : (_ctx.dataSet?.confirmPassword && _ctx.dataSet?.password && _ctx.dataSet?.confirmPassword !== _ctx.dataSet?.password)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('loginRegister.differentPassword')), 1))
                    : _createCommentVNode("", true),
                (_ctx.dataSet?.isShowCaptcha)
                  ? (_openBlock(), _createBlock(CaptchaField, {
                      key: 4,
                      modelValue: captcha.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((captcha).value = $event)),
                      "captcha-img": _ctx.dataSet?.captchaImg,
                      onValueChanged: captchaChage,
                      onUpdateCaptcha: getCaptchaImageData,
                      labelText: _ctx.$t('loginRegister.captchaEnter')
                    }, null, 8, ["modelValue", "captcha-img", "labelText"]))
                  : _createCommentVNode("", true),
                (_ctx.dataSet?.signType == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_ctx.dataSet?.showSMSOTP)
                        ? (_openBlock(), _createBlock(InputField, {
                            key: 0,
                            modelValue: smsOTP.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((smsOTP).value = $event)),
                            onValueChanged: smsOTPChange,
                            ref_key: "smsOTPRef",
                            ref: smsOTPRef,
                            labelText: _ctx.$t('loginRegister.smsCode'),
                            fieldType: "number",
                            isOTP: true,
                            onGetOtp: getSMSOTP
                          }, null, 8, ["modelValue", "labelText"]))
                        : _createCommentVNode("", true),
                      (_ctx.dataSet?.showWhatsappOTP)
                        ? (_openBlock(), _createBlock(InputField, {
                            key: 1,
                            modelValue: whatsappOTP.value,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((whatsappOTP).value = $event)),
                            onValueChanged: whatsappOTPChange,
                            ref_key: "whatsappOTPRef",
                            ref: whatsappOTPRef,
                            labelText: _ctx.$t('loginRegister.whatsappCode'),
                            fieldType: "number",
                            isOTP: true,
                            onGetOtp: getWhatsappOTP
                          }, null, 8, ["modelValue", "labelText"]))
                        : _createCommentVNode("", true),
                      (_ctx.dataSet?.showEmailOTP)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(InputField, {
                              modelValue: email.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((email).value = $event)),
                              isShowError: _ctx.dataSet?.emailValidationNotice,
                              onValueChanged: emailChange,
                              labelText: _ctx.$t('loginRegister.enteremail'),
                              fieldType: "email"
                            }, null, 8, ["modelValue", "isShowError", "labelText"]),
                            _createElementVNode("div", null, [
                              (_ctx.dataSet?.emailValidationNotice)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('loginRegister.emailFormat')), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(InputField, {
                              modelValue: emailOTP.value,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((emailOTP).value = $event)),
                              onValueChanged: emailOTPChange,
                              ref_key: "emailOTPRef",
                              ref: emailOTPRef,
                              labelText: _ctx.$t('loginRegister.emailCode'),
                              fieldType: "number",
                              isOTP: true,
                              onGetOtp: getEmailOTP
                            }, null, 8, ["modelValue", "labelText"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.dataSet?.cloudFlareCaptchaEnabled && _ctx.dataSet?.signType == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", {
                        ref_key: "turnstileContainer",
                        ref: turnstileContainer
                      }, null, 512)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.dataSet?.signType == 0)
                    ? (_openBlock(), _createBlock(MainButton, {
                        key: 0,
                        title: _ctx.$t('common.register'),
                        activeStatus: _ctx.dataSet?.isRegisterBtnActive,
                        onClick: signUp
                      }, null, 8, ["title", "activeStatus"]))
                    : _createCommentVNode("", true),
                  (_ctx.dataSet?.signType == 1)
                    ? (_openBlock(), _createBlock(MainButton, {
                        key: 1,
                        title: _ctx.$t('common.login'),
                        activeStatus: _ctx.dataSet?.isLoginBtnActive,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (signIn(false)))
                      }, null, 8, ["title", "activeStatus"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('loginRegister.regConfirm')), 1)
              ])
            ]))
      ]),
      _createVNode(SliderCaptcha, {
        modelValue: showSliderCaptcha.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showSliderCaptcha).value = $event)),
        onSuccess: handleCaptchaSuccess
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})